import { IconProps } from "./IconType";

export const SimpleCheck = ({ className }: IconProps) => (
  <svg className={className} width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M3.8983 12.0966L8.51 17.6553L21.985 0.979499C22.9938 -0.147265 24.5791 1.05465 23.7864 2.33155L10.5278 23.439C9.51902 24.791 8.14987 24.9413 6.99689 23.5892L0.295396 15.2513C-1.00161 13.2982 2.313 10.5189 3.8983 12.0964V12.0966Z' fill='#111111'/>
  </svg>
);